import { render, staticRenderFns } from "./tribe-box-banner-row.vue?vue&type=template&id=11319f7a&scoped=true&"
import script from "./tribe-box-banner-row.vue?vue&type=script&lang=js&"
export * from "./tribe-box-banner-row.vue?vue&type=script&lang=js&"
import style0 from "./tribe-box-banner-row.vue?vue&type=style&index=0&id=11319f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11319f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11319f7a')) {
      api.createRecord('11319f7a', component.options)
    } else {
      api.reload('11319f7a', component.options)
    }
    module.hot.accept("./tribe-box-banner-row.vue?vue&type=template&id=11319f7a&scoped=true&", function () {
      api.rerender('11319f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/tribe-box-banner-row.vue"
export default component.exports